var map = {
	"./2024.01/data.yml": "f2c4",
	"./2024.02/data.yml": "d360",
	"./2024.03/data.yml": "640f",
	"./2024.04/data.yml": "69dc",
	"./2024.05/data.yml": "d351",
	"./2024.06/data.yml": "5321",
	"./2024.07/data.yml": "8982",
	"./2025.01/data.yml": "c449",
	"./2025.02/data.yml": "6faa",
	"./essen-2025.03/data.yml": "00df",
	"./essen-2025.04/data.yml": "a59d",
	"./essen-2025.05/data.yml": "0398",
	"./essen-2025.06/data.yml": "5aa1",
	"./essen-2025.07/data.yml": "7b06",
	"./essen-2025.08/data.yml": "9ce5",
	"./essen-2026.01/data.yml": "0b3f",
	"./muenchen-2025.06/data.yml": "d3af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd7b";